<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xjrdAQ/tc-custom/9781555848125.jpg?1706210546059" alt="This image is the cover for the book Remembering the Bones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Remembering the Bones
      </h1>
      <p class="bookDescription body article font2">
        <b>A life hangs in the balance of memory in this poignant, witty and “effective feminine counterpoint to . . . Philip Roth’s 2006 novel, ‘Everyman’<i>”</i> by the award-winning author (<i>The Washington Post</i>).</b><br/>                      <br/> Born on the same day as Queen Elizabeth II, Canadian Georgina Danforth Witley is one of ninety-nine lucky Commonwealth residents invited to Her Majesty’s eightieth birthday lunch at Buckingham Palace. But en route to the airport to board the plane for London, Georgina’s car slips off the road and plunges into a thickly wooded ravine. Thrown from the car, injured, and unable to move, she must rely on her full store of family memories, her no-nonsense wit, and a recitation of the names of the bones in her body—an exercise from childhood—to remind her that she is still very much alive. But what has the entirety of her life meant? As Georgina lies stranded and helpless, she reflects on her eighty years as a daughter, mother, sister, wife, and widow, on lost loves and secrets, and on painful moments of the past she struggles not to recall.<br/>  <br/> With this exquisite, suspenseful, and surprising tale of the staying power of family through time and memory, “Itani exposes the richness and depth beneath the surface of one ordinary life” (<i>The New Yorker</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Itani
      </h2>
      
      <p class="authorDescription body article"><B>Frances Itani</B> is the author of fifteen books including <I>Requiem</I>, chosen by the Washington Post as one of 2012&rsquo;s top fiction titles of the year; and the #1 bestseller <I>Deafening</I>, which won a Commonwealth Award, was shortlisted for the International IMPAC Dublin Literary Award, and was published in seventeen territories. Passionate about learning and education, she has taught creative writing at universities, schools, libraries and workshops, across Canada and in Europe. She holds a BA in Psychology, an MA in English Literature, and has completed a graduate year in nursing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c363ebd